import { useContext, useMemo, useState } from 'react';
import { GlobalStateDataContext } from '../../../context-api/data-provider/GlobalStateDataProvider';
import { sectionMeta } from './constants';

export const useDeliveryDrivers = () => {
  const [selectedId, setSelectedId] = useState('1');
  const { onLoadInfoResponse } = useContext(GlobalStateDataContext);

  const kitchenName = onLoadInfoResponse?.data?.data?.data?.KitchenInfo?.kitchenName;
  const dedicatedDrivers = useMemo(() => {
    const drivers =
      onLoadInfoResponse?.data?.data?.data?.kitchenOperationObject?.dedicated_drivers || [];

    return [...drivers].sort((a, b) => {
      const aIsKitchenDedicated = String(a?.account_type || '').toLowerCase() === 'kitchendedicateddriver';
      const bIsKitchenDedicated = String(b?.account_type || '').toLowerCase() === 'kitchendedicateddriver';
      if (aIsKitchenDedicated === bIsKitchenDedicated) return 0;
      return aIsKitchenDedicated ? -1 : 1;
    });
  }, [onLoadInfoResponse]);
  const isRefreshingKitchen = Boolean(onLoadInfoResponse?.loading);

  return useMemo(
    () => ({
      selectedId,
      setSelectedId,
      sectionMeta,
      kitchenName,
      dedicatedDrivers,
      isRefreshingKitchen,
    }),
    [selectedId, kitchenName, dedicatedDrivers, isRefreshingKitchen]
  );
};
